import React from "react";
import apartments from "../../data/home_borin/apartments.json";
import plansApartment from "../../data/home_borin/plansApartment.json";
import Plan from "./Plan";
import ImgSlider from "./ImgSlider";

function Apartment() {
  return (
    <>
      <section className="tc-apartment">
        <div className="col-lg-12 d-flex">
          <div className="col-lg-7 p-100">
            <h2 className="js-splittext-lines text-white">
              <span className="fsz-60 text-uppercase font-palast-regular ltspc-10">
                Apartamento
              </span>
            </h2>
            <p className="fsz-16 mt-30 mb-30 color-gray lh-2 ltspc-2 wow zoomIn slow">
              Além de acabamentos de alto padrão e uma infraestrutura de lazer
              completa, os apartamentos são personalizados com a necessidade de
              cada morador, além de serem contemplados com:
            </p>
            <p
              className="color-gray mt-1 wow zoomIn slow ltspc-2 lh-2 wow zoomIn slow"
              data-wow-delay="0.2s"
            >
              <span className="fsz-16">
                <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic text-white">
                  4 suítes{" "}
                </strong>
                ou 3 suítes com
                <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic text-white">
                  {" "}
                  Living estendido.
                </strong>
              </span>
            </p>
            <p
              className="color-gray mt-1 wow zoomIn slow ltspc-2 lh-2 wow zoomIn slow"
              data-wow-delay="0.2s"
            >
              <span className="fsz-16">
                Área privativa
                <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic text-white">
                  {" "}
                  205 m² ou 189 m².
                </strong>
              </span>
            </p>
            <p
              className="color-gray mt-1 wow zoomIn slow ltspc-2 lh-2 wow zoomIn slow"
              data-wow-delay="0.2s"
            >
              <span className="fsz-16">
                <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic text-white">
                  Pé-direito duplo{" "}
                </strong>
                em todo o apartamento.
              </span>
            </p>
            <p
              className="color-gray mt-1 wow zoomIn slow ltspc-2 lh-2 wow zoomIn slow"
              data-wow-delay="0.2s"
            >
              <span className="fsz-16">
                <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic text-white">
                  Esquadrias{" "}
                </strong>
                de PVC.
              </span>
            </p>
            <p
              className="color-gray mt-1 wow zoomIn slow ltspc-2 lh-2 wow zoomIn slow"
              data-wow-delay="0.2s"
            >
              <span className="fsz-16">
                <strong className="fsz-20 lh-2 ltspc-1 font-palast-bold-italic text-white">
                  Automação{" "}
                </strong>
                completa.
              </span>
            </p>
          </div>

          <div className="col-lg-6 bg-white align-content-center p-150 ps-80">
            <h3 className="lh-1 wow zoomIn slow">
              <span className="fsz-35 color-gray font-palast-regular">
                Cada família
              </span>
              <strong className="fsz-40 color-brown2 font-palast-bold-italic">
                {" "}
                é única.
              </strong>
            </h3>

            <p className="fsz-16 mt-30 mb-20 color-gray lh-2 ltspc-2 wow zoomIn slow">
              O Wiser Legacy Residence foi projetado seguindo essa mesma lógica
              de exclusividade, para que cada apartamento seja ímpar.
            </p>

            <button
              onClick={() => window.openModal()}
              className="butn border rounded-pill border-brown1 hover-bg-brown1 text-uppercase color-brown1 mt-20 wow zoomIn slow"
            >
              <span className="ltspc-1"> Quero saber mais </span>
            </button>
          </div>
        </div>
      </section>

      <section className="tc-slider-style" style={{ position: "relative" }}>
        <ImgSlider slides={apartments} />
      </section>
      <Plan id={'plan-apartment'} title={"Plantas"} subTitle={"Apartamentos"} slides={plansApartment} bgColor={"plan-bg-white"} />
    </>
  );
}

export default Apartment;
